import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import {onMounted, onUnmounted, PropType, ref} from "vue";
import {Pagination} from "swiper/modules";


export default /*#__PURE__*/_defineComponent({
  __name: 'CSlider',
  props: {
  items: {
    type: Array as PropType<Array<string>>,
    required: true
  }
},
  setup(__props) {



const slider = ref<HTMLElement|null>(null)
const height = ref(300)
const margin = ref(0)
const content = ref<HTMLElement|null>(null)
const currentIndex = ref(0)

const resize = () => {
  if (slider.value instanceof HTMLElement) {
    height.value = Math.min(Math.max(slider.value.clientWidth * 0.45, 200), 500)
    margin.value = height.value - (height.value * 0.98 * 0.98)
    // margin.value = 0
  }
}

onMounted(resize)

window.addEventListener('resize', resize)

onUnmounted(() => window.removeEventListener('resize', resize))

const scroll = () => {
  if (content.value instanceof HTMLElement) {
    content.value.scrollBy(content.value.clientWidth, 0)
  }
}

const scrollTo = (index: number) => {
  if (content.value instanceof HTMLElement) {
    currentIndex.value = index
    content.value.scrollTo(content.value.clientWidth * index, 0)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper_container = _resolveComponent("swiper-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: "slider",
    ref_key: "slider",
    ref: slider,
    style: _normalizeStyle(`height: ${height.value}px; margin-top: ${margin.value}px`)
  }, [
    _createVNode(_component_swiper_container, {
      style: {
      '--swiper-navigation-color': '#fff',
      '--swiper-pagination-color': '#fff',
    },
      class: "slider__content",
      ref_key: "content",
      ref: content,
      pagination: true,
      modules: [_unref(Pagination)]
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            class: "slider__item",
            key: index,
            style: _normalizeStyle(`background-image: url(${item})`)
          }, null, 8, ["style"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ], 4))
}
}

})